// All long-form content lives on the WordPress blog. This file is the single
// source of truth for where each section actually is, so the landing page and
// footer can never drift apart again.
//
// Note the inconsistent shapes: /advice and /mvps are hand-built landing pages
// on the blog, the rest are raw category archives. If curated /health,
// /quick-wins and /til pages get built later, only the urls below change.

export const BLOG_URL = "https://blog.howtobachelor.com";

export const CATEGORIES = [
  {
    slug: "advice",
    name: "Unsolicited Advice",
    icon: "💬",
    description:
      "Straight talk on goals, hobbies, and knowing when good enough is good enough.",
    cta: "Read the Advice",
    url: `${BLOG_URL}/advice`,
  },
  {
    slug: "health",
    name: "Health",
    icon: "🧠",
    description:
      "Workouts, sleep, and recovery that fit around a real schedule.",
    cta: "Get Healthier",
    url: `${BLOG_URL}/health/`,
  },
  {
    slug: "mvp",
    name: "MVPs",
    icon: "🏆",
    description:
      "Lessons from the men who did it first, from Marcus Aurelius to Calvin Coolidge.",
    cta: "Meet the MVPs",
    url: `${BLOG_URL}/mvps`,
  },
  {
    slug: "quick-wins",
    name: "Quick Wins",
    icon: "⚡",
    description: "Small changes you can make today that pay off immediately.",
    cta: "Win Today",
    url: `${BLOG_URL}/quick-wins/`,
  },
  {
    slug: "til",
    name: "TIL",
    icon: "💡",
    description:
      "Odd facts worth knowing, and the lesson hiding inside each one.",
    cta: "Learn Something",
    url: `${BLOG_URL}/til/`,
  },
];
